const COLORS = ['#F7A8B8', '#7EC8E3', '#F5A623', '#7BC67E', '#B8A9D4', '#FF6B6B', '#FFD93D'];

export function spawnConfetti(containerId: string) {
  const container = document.getElementById(containerId);
  if (!container) return;

  for (let i = 0; i < 60; i++) {
    const el = document.createElement('div');
    el.style.cssText = `
      position: absolute;
      left: ${Math.random() * 100}%;
      top: -${Math.random() * 40}px;
      width: ${5 + Math.random() * 10}px;
      height: ${5 + Math.random() * 10}px;
      background: ${COLORS[Math.floor(Math.random() * COLORS.length)]};
      border-radius: ${Math.random() > 0.5 ? '50%' : '3px'};
      animation: confettiFall ${1.5 + Math.random() * 2}s ease-out ${Math.random() * 0.5}s forwards;
      --drift: ${(Math.random() - 0.5) * 200}px;
    `;
    container.appendChild(el);
  }

  setTimeout(() => {
    container.innerHTML = '';
  }, 3500);
}
